"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containsCustomScheme = exports.isSchemeCustom = void 0;

var isSchemeCustom = function isSchemeCustom(scheme, schemeList) {
  return scheme && (scheme.name === 'user-custom' || !schemeList.find(function (s) {
    return s.name === scheme.name;
  }));
};

exports.isSchemeCustom = isSchemeCustom;

var containsCustomScheme = function containsCustomScheme(schemeList) {
  return schemeList.some(function (s) {
    return s.name === 'user-custom';
  });
};

exports.containsCustomScheme = containsCustomScheme;